import OrderDetailComponent from 'src/components/features/superAdmin/orderDetailComponent';

const DetailOrderPage = () => <OrderDetailComponent />;

export default DetailOrderPage;
